// Countdown for the banner (version 1)
// Instagram-perfect (device-local time)

// Target: Jan 15, 2026 at 11:30 PM (viewer/device local time)
const targetDate = new Date(Date.UTC(2026, 0, 15, 21, 30, 0));

function updateCountdown1() {
  const now1 = Date.now(); // device local time (matches Instagram)
  const distance1 = targetDate1.getTime() - now1;

  if (distance1 <= 0) {
    clearInterval(countdownInterval1);
    document.getElementById('dDays1').innerText = "00";
    document.getElementById('dHours1').innerText = "00";
    document.getElementById('dMinutes1').innerText = "00";
    document.getElementById('dSeconds1').innerText = "00";
    return;
  }

  const days1 = Math.floor(distance1 / (1000 * 60 * 60 * 24));
  const hours1 = Math.floor((distance1 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes1 = Math.floor((distance1 % (1000 * 60 * 60)) / (1000 * 60));
  const seconds1 = Math.floor((distance1 % (1000 * 60)) / 1000);

  document.getElementById('dDays1').innerText = String(days1).padStart(2, '0');
  document.getElementById('dHours1').innerText = String(hours1).padStart(2, '0');
  document.getElementById('dMinutes1').innerText = String(minutes1).padStart(2, '0');
  document.getElementById('dSeconds1').innerText = String(seconds1).padStart(2, '0');
}

const countdownInterval1 = setInterval(updateCountdown1, 1000);
updateCountdown1();
